import { defineStore, acceptHMRUpdate } from 'pinia'

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    notification: {
      show: false,
      title: '',
      description: '',
      variant: 'info',
      hasClose: false,
      icon: undefined,
    },
    dismissTimeoutId: null,
  }),
  actions: {
    setNotification(payload = {}) {
      this.notification = {
        ...this.notification,
        ...payload,
      }
    },

    hideNotification() {
      this.setNotification({ show: false })

      if (this.dismissTimeoutId) {
        clearTimeout(this.dismissTimeoutId)
        this.dismissTimeoutId = null
      }
    },

    sendNotification(payload = {}) {
      if (this.dismissTimeoutId) clearTimeout(this.dismissTimeoutId)

      const timeToShow = payload.timeToShow ?? 8000
      this.setNotification({
        show: payload.show ?? true,
        title: payload.title ?? '',
        description: payload.description ?? '',
        variant: payload.variant ?? 'info',
        hasClose: payload.hasClose ?? false,
        icon: payload.icon ?? undefined,
      })

      this.dismissTimeoutId = setTimeout(() => {
        this.hideNotification()
      }, timeToShow)
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useNotificationStore, import.meta.hot))
}
